import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatStatus } from '../utils/formatStatus';
import '../styles/UserOrders.css';

function UserOrders({ orders }) {
	const navigate = useNavigate();

	return (
		<div className="orders">
			<h2 style={{ margin: 20 }}>Twoje zamówienia</h2>
			{orders && orders.length > 0 ? (
				<div className="orders-list" style={{ display: 'flex', flexDirection: 'column-reverse'}}>
					{orders.map((order) => (
						<div key={order._id} className="order-row" onClick={() => navigate(`/orders/${order._id}`)} style={{ cursor: 'pointer', padding: 12, borderBottom: '1px solid #eee' }}>
							<div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
								<div>
									<div style={{ fontWeight: 700 }}>Zamówienie {order.orderNumber || order._id}</div>
									<div style={{ color: '#666' }}>{new Date(order.createdAt).toLocaleString()}</div>
								</div>
								<div style={{ textAlign: 'right' }}>
									<div style={{ fontWeight: 700 }}>{(order.total || 0).toFixed(2)} PLN</div>
									<div style={{ color: '#666' }}>{formatStatus(order.status)}</div>
								</div>
							</div>
						</div>
					))}
				</div>
			) : (
				<p>Nie masz jeszcze żadnych zamówień.</p>
			)}
		</div>
	);
}

export default UserOrders;
